import { userKeyId } from "./types/user";
import { patientSurgeryKeyId } from "./types/patientSurgery";
import { patientKeyId } from "./types/patient";
import { patientAllergyKeyId } from "./types/patientAllergy";
import { patientdocumentKeyId } from "./types/patientDocument";
import { patientMedicineKeyId } from "./types/patientMedicine";
import { patientRecordKeyId } from "./types/patientRecord";
import { patientRehabKeyId } from "./types/patientRehabProtocol";
import { recordCategoryKeyId } from "./types/recordCategory";
import { rehabFacIdKey } from "./types/rehabFacility";
import { rehabProtocolKeyId } from "./types/rehabProtocol";
import { surgeryTypeKeyId } from "./types/surgeryType";
import { allergyKeyId } from "./types/allergy";
import { implantKeyId } from "./types/implant";
import { medecineKeyId } from "./types/medicine";
import { diseaseKeyId } from "./types/disease";
import { DocumentTypeKeyId } from "./types/documentType";
import {doctorKeyId} from "./types/doctor";
import { specialtyKeyId } from "./types/specialty";
import { medicinedoseKeyId } from "./types/medicineDose";
import { rvKeyId } from "./types/rv";

export const entityIdKeyMap: Record<string, string> = {
  patient: patientKeyId,
  surgery: surgeryTypeKeyId,
  user: userKeyId,
  allergy: allergyKeyId,
  implant: implantKeyId,
  medicine: medecineKeyId,
  medicineDose: medicinedoseKeyId,
  documentType: DocumentTypeKeyId,
  historyType: recordCategoryKeyId,
  rehabCenter: rehabFacIdKey,
  disease: diseaseKeyId,
  patientSurgery: patientSurgeryKeyId,
  patientAllergy: patientAllergyKeyId,
  patientDocument: patientdocumentKeyId,
  patientMedicine: patientMedicineKeyId,
  patientRecord: patientRecordKeyId,
  patientRehabProtocol: patientRehabKeyId,
  rehabProtocol: rehabProtocolKeyId,
  doctor: doctorKeyId,
  specialty : specialtyKeyId,
  rv: rvKeyId,
};
